import type { SectionPagesMap } from '../types';
import { CaseSidebarItemId, CaseSidebarSection } from '../types';

export const SECTION_ITEM_ORDER: Record<CaseSidebarSection, CaseSidebarItemId[]> = {
  [CaseSidebarSection.DOCUMENTS]: [CaseSidebarItemId.CUSTOMER_FILES, CaseSidebarItemId.EVIDENCE],
  [CaseSidebarSection.APPLICATION]: [
    CaseSidebarItemId.FINANCING,
    CaseSidebarItemId.APPLICANTS,
    CaseSidebarItemId.PRODUCT,
    CaseSidebarItemId.PROPERTY,
    CaseSidebarItemId.TOP_SLICING,
    CaseSidebarItemId.AFFORDABILITY_CHECK,
    CaseSidebarItemId.SUBMIT_DIP,
    CaseSidebarItemId.SOLICITORS,
    CaseSidebarItemId.BANK_DETAILS,
    CaseSidebarItemId.SUBMIT_APPLICATION,
    CaseSidebarItemId.VALUATION,
    CaseSidebarItemId.POST_OFFER,
  ],
  [CaseSidebarSection.OTHER]: [CaseSidebarItemId.COMMUNICATION, CaseSidebarItemId.ADDITIONAL_INFORMATION],
};

export function sortItemsBySectionOrder(section: CaseSidebarSection, items: CaseSidebarItemId[]): CaseSidebarItemId[] {
  const order = SECTION_ITEM_ORDER[section];
  const orderedItems = order.filter(itemId => items.includes(itemId));
  const unorderedItems = items.filter(itemId => !order.includes(itemId));

  return [...orderedItems, ...unorderedItems];
}

export function sortSectionPagesMap(pages: SectionPagesMap): SectionPagesMap {
  return {
    [CaseSidebarSection.DOCUMENTS]: sortItemsBySectionOrder(
      CaseSidebarSection.DOCUMENTS,
      pages[CaseSidebarSection.DOCUMENTS],
    ),
    [CaseSidebarSection.APPLICATION]: sortItemsBySectionOrder(
      CaseSidebarSection.APPLICATION,
      pages[CaseSidebarSection.APPLICATION],
    ),
    [CaseSidebarSection.OTHER]: sortItemsBySectionOrder(CaseSidebarSection.OTHER, pages[CaseSidebarSection.OTHER]),
  };
}
